import { OURO } from '@/pages/loja/identidade';

interface Props {
  copiado: boolean;
  aoCopiar: () => void;
  aoWhatsApp: () => void;
  vinculada: boolean;
  logado: boolean;
  vinculando: boolean;
  aoVincular: () => void;
  aoEntrar: () => void;
}

// Uma linha só, três ícones-botão: copiar link · WhatsApp · guardar na conta.
// Cartões escuros com borda clara (mesma identidade da carteira).
export default function GuardarCarteira({
  copiado,
  aoCopiar,
  aoWhatsApp,
  vinculada,
  logado,
  vinculando,
  aoVincular,
  aoEntrar,
}: Props) {
  const base =
    'aperta flex h-[64px] flex-1 cursor-pointer flex-col items-center justify-center gap-1 rounded-[14px] border border-white/10 bg-white/[0.05] text-white/85 transition-colors hover:bg-white/[0.08] disabled:opacity-60';
  const rotulo = 'text-[11px] font-semibold leading-none';

  return (
    <div className="mt-6">
      <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-white/40">
        Guardar esta carteira
      </p>
      <div className="mt-2 flex gap-2">
        <button type="button" onClick={aoCopiar} className={base}>
          <span className="flex h-6 w-6 items-center justify-center">
            <i
              className={copiado ? 'ri-check-line text-[20px]' : 'ri-link text-[20px]'}
              aria-hidden
              style={copiado ? { color: OURO } : undefined}
            />
          </span>
          <span className={rotulo}>{copiado ? 'Link copiado' : 'Copiar link'}</span>
        </button>

        <button type="button" onClick={aoWhatsApp} className={base}>
          <span className="flex h-6 w-6 items-center justify-center">
            <i className="ri-whatsapp-line text-[20px] text-[#25D366]" aria-hidden />
          </span>
          <span className={rotulo}>WhatsApp</span>
        </button>

        {!vinculada ? (
          <button
            type="button"
            onClick={logado ? aoVincular : aoEntrar}
            disabled={vinculando}
            className={base}
          >
            <span className="flex h-6 w-6 items-center justify-center">
              <i className="ri-user-add-line text-[20px]" aria-hidden />
            </span>
            <span className={rotulo}>
              {logado ? (vinculando ? 'Guardando…' : 'Na conta') : 'Entrar e guardar'}
            </span>
          </button>
        ) : (
          <div
            className="flex h-[64px] flex-1 flex-col items-center justify-center gap-1 rounded-[14px] border"
            style={{ borderColor: 'rgba(232,200,119,0.45)', background: 'rgba(232,200,119,0.10)', color: OURO }}
          >
            <span className="flex h-6 w-6 items-center justify-center">
              <i className="ri-check-double-line text-[20px]" aria-hidden />
            </span>
            <span className={rotulo}>Na sua conta</span>
          </div>
        )}
      </div>
    </div>
  );
}